import { createFiltersActions } from '../utils';

export const ACTIONS_PREFIX = 'ARCHIVE_FILTERS';

export const {
    updateFilters,
    applyFilters,
    resetApplyFilters,
    resetApplyFiltersSilently,
    rebuildApplyFilters,
    rebuildApplyFiltersSilently
} = createFiltersActions(ACTIONS_PREFIX);
